import { createContext } from "react";
export const DailySalesContext = createContext(null);
